import { type HTMLAttributes } from 'react';
import { Label } from '../ui/label';
import { RadioGroup, RadioGroupItem } from '../ui/radio-group';
import { cn } from '@/lib/utils';

export interface RadioProps extends HTMLAttributes<HTMLButtonElement> {
	defaultValue: string;
	options: RadioItemProps[];
	square?: boolean;
}

interface RadioItemProps extends HTMLAttributes<HTMLButtonElement> {
	value: string;
	label?: string;
	square?: boolean;
}

const FoundationRadioItem = ({
	value,
	label,
	square,
	...rest
}: RadioItemProps) => {
	return (
		<div className='wlcb-flex wlcb-items-center wlcb-space-x-2'>
			<RadioGroupItem
				{...rest}
				className={cn(
					'wlcb-text-white data-[state=checked]:wlcb-bg-surface-inverse data-[state=checked]:hover:wlcb-bg-surface-hover-inverse wlcb-bg-surface hover:wlcb-bg-surface-hover',
					{
						'wlcb-rounded-sm': square,
					}
				)}
				square={square}
				value={value}
				id={value}
			/>
			{label ? (
				<Label
					style={{ color: 'var(--text-secondary)' }}
					className='wlcb-text-caption wlcb-font-[400]'
					htmlFor={value}
				>
					{label}
				</Label>
			) : null}
		</div>
	);
};

const FoundationRadio = ({
	defaultValue,
	options,
	square,
	...rest
}: RadioProps) => {
	return (
		<RadioGroup defaultValue={defaultValue}>
			{options.map((radioItem) => (
				<FoundationRadioItem
					{...rest}
					square={square}
					key={radioItem.value}
					value={radioItem.value}
					label={radioItem.label ?? undefined}
				/>
			))}
		</RadioGroup>
	);
};

export default FoundationRadio;
